import { Component } from '@angular/core';
import { MensIntimateWashComponent } from '@components/consultation-request/upsells/mens-intimate-wash/mens-intimate-wash.component';

@Component({
  selector: 'app-mens-intimate-wash-zofran',
  imports: [MensIntimateWashComponent],
  templateUrl: './mens-intimate-wash-zofran.component.html',
})
export class MensIntimateWashZofranComponent {}
